import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Appraisal, AppraisalQuarter, AppraiseeObject, Approval, ApprovalList, EmployeeAssesment, EmployeeLOne, EvaluationReport, Metric, Objective, PerformanceDto, PromotionDto, Quarter } from '../models/appraisal';
import { Evaluation, Message } from '../models/domain';
import { HttpClient } from '@angular/common/http';
import { Hike } from '../models/appraisal';

@Injectable({
  providedIn: 'root'
})
export class ApparaisalService {
  setToastr(arg0: number, text: any) {
    throw new Error('Method not implemented.');
  }

  constructor(private httpClient: HttpClient) { }

  // APPRAISAL CYCLE

  public getAppraisals(): Observable<Appraisal[]> {
    return this.httpClient.get<Appraisal[]>('/api/appraisal/v1');
  }

  public getAppraisal(id: number): Observable<Appraisal> {
    return this.httpClient.get<Appraisal>(`/api/appraisal/v1/${id}`);
  }

  public createAppraisal(appraisal: Appraisal): Observable<Message> {
    return this.httpClient.post<Message>('/api/appraisal/v1', appraisal);
  }

  public updateAppraisal(id: number, appraisal: Appraisal): Observable<Message> {
    return this.httpClient.put<Message>(`/api/appraisal/v1/${id}`, appraisal);
  }

  public deleteAppraisal(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/appraisal/v1/${id}`);
  }

  public getAppraisalStatus(): Observable<string[]> {
    return this.httpClient.get<string[]>(`/api/appraisal/v1/status`);
  }

  // public toggleAppraisalStatus(appraisal: Appraisal): Observable<Message> {
  //   return this.httpClient.put<Message>(`/api/appraisal/v1/${appraisal.id}`, appraisal);
  // }

  public toggleAppraisalStatus(id: number, active: boolean): Observable<Message> {
    return this.httpClient.patch<Message>(`/api/appraisal/v1/appraisal-status/${id}?active=${active}`, {});
  }

  public getObjectives(appraisalId: number, quarterId?: number): Observable<Objective[]> {
    return this.httpClient.get<Objective[]>(`/api/appraisal/v1/objective?appraisalId=${appraisalId}`, { params: { ...(quarterId && { quarterId }) } });
  }

  public getObjective(id: number): Observable<Objective> {
    return this.httpClient.get<Objective>(`/api/appraisal/v1/objective/${id}`);
  }
  public createObjective(objective: Objective[]): Observable<Message> {
    return this.httpClient.post<Message>('/api/appraisal/v1/objective', objective);
  }
  public updateObjective(id: number, objective: Objective[]): Observable<Message> {
    return this.httpClient.put<Message>(`/api/appraisal/v1/objective/${id}`, objective);
  }
  public deleteObjective(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/appraisal/v1/objective/${id}`);
  }
  public submitObjective(appraisalId: number): Observable<Message> {
    return this.httpClient.patch<Message>(`/api/appraisal/v1/objective/${appraisalId}`, {});
  }
  // quarter
  public getQuarters(appraisalId: number): Observable<Quarter[]> {
    return this.httpClient.get<Quarter[]>(`/api/appraisal/v1/quarters/${appraisalId}`);
  }
  public getAppraisalQuarters(disabled?:boolean): Observable<AppraisalQuarter[]> {
    return this.httpClient.get<AppraisalQuarter[]>(`/api/appraisal/v1/quarters`,{ params: { ...(disabled != null && { disabled }) } });
  }

  public getAppraiseeObjects(appraiseeId: number, quarterId: number): Observable<AppraiseeObject[]> {
    return this.httpClient.get<AppraiseeObject[]>(`/api/appraisal/v1/appraisee-objective/${appraiseeId}/${quarterId}`);
  }
  // approval

  public getApprovalList(appraisalId: number): Observable<ApprovalList[]> {
    return this.httpClient.get<ApprovalList[]>(`/api/appraisal/v1/approvals/${appraisalId}`)
  }

  public saveApproval(approval: Approval[],appraisalId: number, appraiseeId: number,lone:boolean): Observable<Message> {
    return this.httpClient.put<Message>(`/api/appraisal/v1/approve-objective?appraisalId=${appraisalId}&appraiseeId=${appraiseeId}&lone=${lone}`, approval);
  }
  public updateApproval(approval: Approval[],appraisalId: number, appraiseeId: number,lone:boolean): Observable<Message> {
    return this.httpClient.put<Message>(`/api/appraisal/v1/approve-objective?appraisalId=${appraisalId}&appraiseeId=${appraiseeId}&lone=${lone}`, approval);
  }

  //performance

  public getPerformances(): Observable<PerformanceDto[]> {
    return this.httpClient.get<PerformanceDto[]>('/api/appraisal/v1/performances')
  }

  public getPerformance(id: number,): Observable<Performance> {
    return this.httpClient.get<Performance>(`/api/appraisal/v1/performance/${id}`);
  }
  //getmatric

  public getMatrics(): Observable<Metric[]> {
    return this.httpClient.get<Metric[]>('/api/appraisal/v1/metrics')
  }

  public getMertic(id:number): Observable<Metric> {
    return this.httpClient.get<Metric>(`/api/appraisal/v1/metric/${id}`)
  }

  //Hike

  public getHike(assessmentId: number): Observable<Hike[]> {
    return this.httpClient.get<Hike[]>(`/api/appraisal/v1/hikes/${assessmentId}`)
  }

  public createHike(hike: Hike): Observable<Message> {
    return this.httpClient.post<Message>('/api/appraisal/v1/hike', hike)
  }

  public updateHike(id: number,hike: Hike): Observable<Message> {
    return this.httpClient.put<Message>(`/api/appraisal/v1/hike/${id}`, hike)
  }
  //Promotion

  public createPromotion(promotion: PromotionDto): Observable<Message> {
    return this.httpClient.post<Message>('/api/appraisal/v1/promotion', promotion)
  }

  public updatePromotion(id: number, promotion: PromotionDto): Observable<Message> {
    return this.httpClient.put<Message>(`/api/appraisal/v1/promotion/${id}`, promotion)
  }

  public getPromotions(id: number): Observable<PromotionDto[]> {
    return this.httpClient.get<PromotionDto[]>(`/api/appraisal/v1/promotions/${id}`)
  }

  //save appraisal

  public updateApprovalForm(id: number, approval: EmployeeAssesment): Observable<Message> {
    return this.httpClient.put<Message>(`/api/appraisal/v1/assessment/${id}`, approval)
  }

  public updateAppraisalStatus(id: number, status: string): Observable<Message> {
    return this.httpClient.put<Message>(`/api/appraisal/v1/assessment/status/${id}/${status}`,{})
  }

  // emploLone
  public getEmployeeLOne(): Observable<EmployeeLOne[]> {
    return this.httpClient.get<EmployeeLOne[]>(`/api/appraisal/v1/appraisees`);
  }
  // emploass
  public getEmployeeAppraisalDetails(appraisalId: number, appraiseeId: number): Observable<EmployeeAssesment> {
    return this.httpClient.get<EmployeeAssesment>(`/api/appraisal/v1/assessment/${appraisalId}/${appraiseeId}`);
  }
  // GET OBJ EM
  public getObjectiveEmployees(appraiseeId: number, appraisalId: number): Observable<Approval[]> {
    return this.httpClient.get<Approval[]>(`/api/appraisal/v1/appraisee-objective/${appraiseeId}/${appraisalId}`);
  }

  public checkObjectiveStatus(appraisalId: number): Observable<Message> {
    return this.httpClient.get<Message>(`/api/appraisal/v1/objective-submit-check/appraisee/${appraisalId}`, {});
  }

  //Evaluation

  public createEvaluation(evaluation: Evaluation): Observable<Message> {
    return this.httpClient.post<Message>('/api/appraisal/v1/evaluation', evaluation);
  }

  public getEvaluation(id: number): Observable<Evaluation> {
    return this.httpClient.get<Evaluation>(`/api/appraisal/v1/evaluation/${id}`);
  }

  public getEvaluations(assessmentId: number): Observable<Evaluation> {
    return this.httpClient.get<Evaluation>(`/api/appraisal/v1/evaluations/${assessmentId}`);
  }

  public updateEvaluation(id: number, evaluation: Evaluation): Observable<Message> {
    return this.httpClient.put<Message>(`/api/appraisal/v1/evaluation/${id}`, evaluation);
  }

  public getEvaluationList(appraisalId: number): Observable<ApprovalList[]> {
    return this.httpClient.get<ApprovalList[]>(`/api/appraisal/v1/evaluation/approvals/${appraisalId}`)
  }

  public getEvaluationReport(addresseeId:number,appraisalId: number, applicable?: boolean, promotable?: boolean, evaluation?: boolean): Observable<EvaluationReport[]> {
    return this.httpClient.get<EvaluationReport[]>(`/api/appraisal/v1/evaluation/reports/${addresseeId}/${appraisalId}`, { params: { ...applicable != null && { applicable }, ...(promotable != null && { promotable }), ...(evaluation != null && { evaluation }) } })
  }

  //assessment-summary
  public getAssessment(appraisalId: number, appraiseeId: number): Observable<EmployeeAssesment> {
    return this.httpClient.get<EmployeeAssesment>(`/api/appraisal/v1/assessment-summary/${appraisalId}/${appraiseeId}`);
  }

  public getAssessments(appraisalId: number, appraiseeId: number): Observable<EmployeeAssesment> {
    return this.httpClient.get<EmployeeAssesment>(`/api/appraisal/v1/assessment/${appraisalId}/${appraiseeId}`);
  }
}



